import Loadable from 'react-loadable';
import Loading from 'modules/common/components/Loading';

const AsyncTransactionContainer = Loadable({
  loader: () => import('./container/TransactionContainer' /* webpackChunkName: "transaction.transaction-container" */),
  loading: Loading,
});

export default AsyncTransactionContainer;
